import { NgClass, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';

import { LoadingIndicatorComponent } from './loading-indicator.component';

/**
 * Angular module for the {@link LoadingIndicatorComponent}.
 *
 * @remarks
 * Provides the LoadingIndicatorComponent and its required Angular Common module
 * dependencies (NgClass, NgTemplateOutlet). Import this module to use the
 * `bb-loading-indicator-ui` component in your templates.
 *
 * @example
 *
 * ```typescript
 * import { LoadingIndicatorModule } from '@backbase/ui-ang-components';
 *
 * @NgModule({
 *   imports: [LoadingIndicatorModule]
 * })
 * export class MyFeatureModule {}
 * ```
 */
@NgModule({
  imports: [NgClass, NgTemplateOutlet],
  declarations: [LoadingIndicatorComponent],
  exports: [LoadingIndicatorComponent],
})
export class LoadingIndicatorModule {}
